import auth from "./modules/auth"
import account from "./modules/account"
import residences from "./modules/residences"
import breadCrumb from "./modules/breadCrumb"
import mobipass from "./modules/mobipass"
import apiDataCache from "./modules/apiDataCache"

export default {
    resetAll(state, payload) {
        state.account = account.state()
        state.auth = auth.state()
        state.residences = residences.state()
        state.breadCrumb = breadCrumb.state()
    },

    disconnect(state, payload) {
        state.account = account.state()
        state.auth = auth.state()
        state.residences = residences.state()
        state.breadCrumb = breadCrumb.state()
        state.mobipass = mobipass.state()
        state.apiDataCache = apiDataCache.state()
    },
}
